import {
  Box,
  Button,
  DialogTitle,
  ListItem,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Colors } from "../theme";

export const StyledPieChartBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "400px",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    height: "300px",
  },

  "& .pie-title": {
    marginTop: "-60px",
    marginBottom: "16px",
    marginLeft: "66px",
  },
}));

export const chartColors = {
  resolved: "#1DCD9F",
  pending: "#8E1616", // Dark red color
  total: "#FBF5DD", // Yellow color
};

export const CloseButton = styled(Button)(({ theme }) => ({
  backgroundColor: Colors.primary, // Set the button background color
  color: Colors.white, // Set the text color
  "&:hover": {
    backgroundColor: Colors.hover, // Darken the color on hover
  },
}));

export const StyledContainer = styled(Box)({
  justifyContent: "space-between",
  height: "100vh,",
  alignItems: "flex-end",
  marginTop: "2rem",
  width: "100%", // Equivalent to mt={5}

  '& .close_button':{
    backgroundColor: Colors.primary, // Set the button background color
    color: Colors.white, // Set the text color
    "&:hover": {
      backgroundColor: Colors.hover, // Darken the color on hover
    },
  },

  " & .ticket_main_title": {
    color: Colors.primary,
    textAlign: "center",
  },

  " & .filter-box": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 0,
    overview: "hidden",
  },

  " & .chart-grid-container": {
    marginTop: "40px",
    justifyContent: " center",
  },

  " & .loader-box": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  " & .styled-box": {
    flex: 1,
  },

  " & .styled-tabs": {
    marginBottom: "1rem",
  },
  " & .styled-tab": {
    color: Colors.primary,
  },

  " & .ticket-details-dialog": {
    width: "100%",
    maxWidth: "400px", // same as maxWidth="sm"
    margin: "16px",
    borderRadius: "12px",
  },
  "& .MuiDialog-paper": {
    width: "100%",
    maxWidth: "500px",  
    margin: "16px",
    borderRadius: "12px",
  },
  "& .styled_text_field": {},
  " & .styled_remarks_field": {
    marginTop: "16px",
  },
  "& .styled_dialog_title": {
    backgroundColor: Colors.primary,
    color: "white",
    textAlign: "center",
    fontWeight: "bold",
    margin: 0,
    padding: "0.5rem",
    lineHeight: 1.4,
    marginBottom: "1rem",
  },
  "& .styled_typography": {
    marginBottom: "0.5rem",
  },
});

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderBottom: "1px solid #ddd",
  paddingBottom: "1rem",
  overflow: "hidden",

  " & .styled_button": {
    marginTop: "0.5rem",
    padding: 0,
    textDecoration: "underline",
    fontSize: "14px",
    color: Colors.primary,
  },
}));

export const StyledFiltersWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
  "& .styled_button": {
    padding: "0 16px",
    backgroundColor: Colors.primary,
    color: "white",
    "&:hover": {
      backgroundColor: Colors.hover,
    },
  },
  "& .styled_text_field": {
    zIndex: 0.1,
    width: "170px",
    minWidth: "170px",
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: Colors.primary,
  color: "white",
  textAlign: "center",
  fontWeight: "bold",
  margin: 0,
  padding: "0.5rem",
  lineHeight: 1.4,
  marginBottom: "1rem",
}));
